module.exports = __webpack_public_path__ + "static/media/37-2.5b2d5847.mp3";